function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_197",
  "data-name": "Group 197",
  transform: "translate(-245.417 -626.407)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  "data-name": "Path 79",
  d: "M4532.069,153.922h-13.1a1.636,1.636,0,0,1-1.636-1.636v-17.14a1.636,1.636,0,0,1,1.636-1.636h13.1a1.636,1.636,0,0,1,1.635,1.636v17.14A1.635,1.635,0,0,1,4532.069,153.922Z",
  transform: "translate(-4271.166 496.817)",
  fill: "none",
  stroke: "#f65e5c",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_4",
  "data-name": "Line 4",
  x1: 16.305,
  transform: "translate(246.101 637.721)",
  fill: "none",
  stroke: "#f65e5c",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_5",
  "data-name": "Line 5",
  y1: 8.241,
  transform: "translate(250.509 626.407)",
  fill: "none",
  stroke: "#f65e5c",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_6",
  "data-name": "Line 6",
  y1: 8.241,
  transform: "translate(257.998 626.407)",
  fill: "none",
  stroke: "#f65e5c",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}));

var SvgCalenderIcon = function SvgCalenderIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.871,
    height: 25.082,
    viewBox: "0 0 17.871 25.082",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalenderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calender-icon.8dc520cc.svg";
export { ForwardRef as ReactComponent };